import React from 'react';
import { Question, Answer } from '../types';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Label } from '@/components/ui/label';

interface QuestionCardProps {
  question: Question;
  answer: Answer;
  onChange: (answer: Answer) => void;
}

const QuestionCard: React.FC<QuestionCardProps> = ({ question, answer, onChange }) => {
  return (
    <div className="p-6 bg-background border rounded-md shadow mb-6" style={{ WebkitTapHighlightColor: 'rgba(0,0,0,0)', touchAction: 'manipulation' }}>
      <div className="mb-4">
        <p className="text-foreground">{question.text}</p>
      </div>
      
      <div className="mt-6">
        <RadioGroup 
          value={answer} 
          onValueChange={(value) => onChange(value as Answer)}
          className="space-y-3"
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="Yes" id={`${question.id}-yes`} />
            <Label htmlFor={`${question.id}-yes`} className="text-foreground">Yes</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="No" id={`${question.id}-no`} />
            <Label htmlFor={`${question.id}-no`} className="text-foreground">No</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="Unsure" id={`${question.id}-unsure`} />
            <Label htmlFor={`${question.id}-unsure`} className="text-foreground">Unsure</Label>
          </div>
        </RadioGroup>
      </div>
    </div>
  );
};

export default QuestionCard;
